// de_pms_reports.ts
// Übersetzungen für PMS.Reports – Live-Betriebsberichts-Snapshot

export const dePmsReports = {

  title: "Berichte",
  subtitle: "Aktuelle operative Berichte des Hotels.",

  // ── Kennzahlen ────────────────────────────────────────────────────────────
  metrics: {
    occupancy:        "Auslastung",
    reservations:     "Reservierungen",
    checkedIn:        "Eingecheckt",
    checkedOut:       "Ausgecheckt",
    currentProperty:  "Aktuelles Hotel",
    liveStatus:       "Live-Status",
  },

  // ── Primärtabelle ─────────────────────────────────────────────────────────
  primary: {
    title:              "Betriebskennzahlen",
    subtitle:           "Aktuelle Hotelaktivität.",
    arrivalsToday:      "Anreisen heute",
    departuresToday:    "Abreisen heute",
    totalCharges:       "Gesamtbelastungen",
    totalPayments:      "Gesamtzahlungen",
    outstandingBalance: "Offener Saldo",
  },

  // ── Marktsegment-Tabelle ──────────────────────────────────────────────────
  marketSegment: {
    title:            "Marktsegment-Mix",
    subtitle:         "Reservierungen nach Marktsegment.",
    emptyLabel:       "Marktsegmente",
    emptyValue:       "Keine Daten",
    reservationCount: "{{count}} Reservierung(en)",
  },

  // ── Quellen & Pickup-Tabelle ──────────────────────────────────────────────
  sourcePickup: {
    title:              "Quellen-Performance",
    subtitle:           "Buchungen nach Quelle und Kanal.",
    emptySourceLabel:   "Buchungsaufkommen nach Quelle",
    emptySourceValue:   "Keine Daten",
    reservationCount:   "{{count}} Reservierung(en)",
  },

  pickup: {
    title:      "Pickup (7 Tage)",
    subtitle:   "Pro Tag erstellte Buchungen in den letzten 7 Tagen.",
    emptyValue: "Keine Daten",
  },

  meta: {
    generatedAt: "Snapshot erstellt",
  },

} as const;

export default dePmsReports;
